import React, { useState, useEffect, useMemo } from "react";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import ListaMotorista from "../../Componentes/ListaMotorista";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

import "./styles.css";

const SITUACAO_ATIVO = 1;
const SITUACAO_INATIVO = 2;

const Menu = () => {
  const [dadosMotorista, setdadosMotorista] = useState([]);
  const [filtro, setfiltro] = useState("");
  const [ordenacao, setOrdenacao] = useState("nome");
  const [situacaoFiltro, setSituacaoFiltro] = useState(SITUACAO_ATIVO);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem("usuarioLogado") === null) {
      navigate("/");
    }
  }, [navigate]);

  useEffect(() => {
    carregaListaMotorista(filtro);

    const intervaloMenu = setInterval(() => {
      carregaListaMotorista(filtro);
    }, 60000);

    return () => clearInterval(intervaloMenu);
  }, [filtro, situacaoFiltro]);

  async function carregaListaMotorista(busca) {
    const retorno = await buscaMotoristas(busca);

    if (retorno?.data) {
      const motoristasFiltrados = retorno.data.filter(
        (motorista) => Number(motorista.situacao) === situacaoFiltro
      );
      setdadosMotorista(motoristasFiltrados);
      return;
    }

    setdadosMotorista([]);
  }

  async function buscaMotoristas(busca) {
    try {
      const response = await api.get("/motoristas?filter=" + busca);
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  const listaOrdenada = useMemo(() => {
    const lista = [...dadosMotorista];

    return lista.sort((a, b) => {
      if (ordenacao === "nome") {
        return a.nome.localeCompare(b.nome);
      }
      if (ordenacao === "idCarga") {
        return a.IDlote - b.IDlote;
      }
      if (ordenacao === "valorCarga") {
        return b.ValorEntregas - a.ValorEntregas;
      }
      if (ordenacao === "datahora") {
        return new Date(b.datahora) - new Date(a.datahora);
      }
      return 0;
    });
  }, [dadosMotorista, ordenacao]);

  const exibindoInativos = situacaoFiltro === SITUACAO_INATIVO;

  function alternarListaMotoristas() {
    setSituacaoFiltro((situacaoAtual) =>
      situacaoAtual === SITUACAO_ATIVO ? SITUACAO_INATIVO : SITUACAO_ATIVO
    );
  }

  return (
    <div className="menu-container-menu">
      <MenuLateral />

      <div id="painel_principal_menu" align="center">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            paddingBottom: "1%",
            flexWrap: "wrap",
          }}
        >
          <h4 style={{ margin: 0 }}>
            Motoristas | MONITORAMENTO DE ENTREGAS
          </h4>
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={alternarListaMotoristas}
          >
            {exibindoInativos ? "Ver ativos" : "Ver inativos"}
          </button>
        </div>
        {exibindoInativos && (
          <h5 style={{ color: "#b02a37", fontWeight: "bold", marginBottom: "1rem" }}>
            Lista de motoristas inativos
          </h5>
        )}
        <div style={{ width: "100%", textAlign: "center", marginBottom: "0.5rem" }}>
          <small style={{ color: "#6c757d", fontSize: "0.8rem" }}>
            {listaOrdenada.length} motoristas
          </small>
        </div>
        <div id="div_painel_menu">
          <div
            style={{
              display: "flex",
              alignItems: "end",
              width: "100%",
              paddingLeft: "3%",
              paddingRight: "3%",
              gap: "20px",
              flexWrap: "wrap",
              boxSizing: "border-box",
            }}
          >
            <div className="form-group mb-3" style={{ flex: 1, minWidth: "320px" }}>
              <label htmlFor="buscar" className="form-label" style={{ fontSize: "0.8em" }}>
                Filtro:
              </label>
              <div className="input-group" style={{ width: "100%" }}>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  id="buscar"
                  placeholder="Digite sua busca (Nome ou Placa)"
                  style={{ textAlign: "center", fontSize: "1.2em" }}
                  value={filtro}
                  onChange={(e) => setfiltro(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      carregaListaMotorista(e.target.value);
                    }
                  }}
                />
                <button
                  type="button"
                  className="btn btn-primary btn-lg"
                  onClick={() => carregaListaMotorista(filtro)}
                >
                  <FaSearch />
                </button>
              </div>
            </div>

            <div className="form-group mb-3" style={{ width: "15%", minWidth: "180px" }}>
              <label htmlFor="ordenacao" className="form-label" style={{ fontSize: "0.8em" }}>
                Ordenar por:
              </label>
              <select
                className="form-control"
                id="ordenacao"
                value={ordenacao}
                onChange={(e) => setOrdenacao(e.target.value)}
              >
                <option value="nome">Nome</option>
                <option value="idCarga">ID Carga</option>
                <option value="datahora">Data da Saida</option>
                <option value="valorCarga">Valor da Carga</option>
              </select>
            </div>
          </div>

          <ListaMotorista listaMotoriista={listaOrdenada} maxHeight="calc(100vh - 260px)" />
        </div>
      </div>
    </div>
  );
};

export default Menu;
